// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'


Vue.use(router)

Vue.config.productionTip = false


import iView from 'iview' // 引入iview依赖
import 'iview/dist/styles/iview.css' // 引入iview css样式
Vue.use(iView) //使用iview组件

import qs from 'qs'
Vue.prototype.$qs = qs

// 引入echarts

//import echarts from 'echarts'
//Vue.prototype.$echarts = echarts

//  全局组件之间通信
//Vue.prototype.$eventHub= Vue.prototype.$eventHub ||  new Vue()  //!!!!!还没有解决


// import vueKanban from 'vue-kanban'

// Vue.use(vueKanban)

import Global from './Global/Global'//引用文件
Vue.prototype.Global = Global//挂载到Vue实例上面

//需要在main中引入组件
// import Mp3play from './HelpUI/Mp3Paly.vue'//引用文件
// Vue.prototype.Mp3play = Mp3play//挂载到Vue实例上面

//打印组件
// import Print from 'vue-print-nb'
// Vue.use(Print);
import Print from '../src/Js/print.js'
Vue.use(Print);

//滚动条样式
import vuescroll from "vuescroll";//引入vuescroll
import "vuescroll/dist/vuescroll.css";//引入vuescroll样式
Vue.use(vuescroll);//使用


Vue.filter('dataFormart', function (value) {
   let dt = new Date(value)
   const yyyy = dt.getFullYear();
   const mm = (dt.getMonth() + 1 + '').padStart(2, '0')
   const dd = (dt.getDate() + '').padStart(2, '0')
   const hh = (dt.getHours() + '').padStart(2, '0')
   const mi = (dt.getMinutes() + '').padStart(2, '0')
   const ss = (dt.getSeconds() + '').padStart(2, '0')
   return `${yyyy}年${mm}月${dd}日 ${hh}:${mi} `
 })

 Vue.filter('dataFormartff', function (value) {
    let dt = new Date(value)
    const yyyy = dt.getFullYear();
    const mm = (dt.getMonth() + 1 + '').padStart(2, '0')
    const dd = (dt.getDate() + '').padStart(2, '0')
    const hh = (dt.getHours() + '').padStart(2, '0')
    return `${yyyy}-${mm}-${dd} `
  })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data:{
  	eventHub: new Vue()
  },
created: function () {
	var that=this;
   //this.$root.eventHub.$on("onSystemError",that.adddd)
  // console.log("onSystemError监听");
   /*//console.log(this);
   //console.log(window);
   this.eventHub.$on("onSystemError",that.adddd)*/
   window.eventHub=new Vue();
   window.eventHub.$on("onSystemError",that.onSystemError)
},
methods: {

    onSystemError(ErrorCode,Message)
    {
            // console.log("onSystemError事件提示"+ErrorCode+Message);
             if(Message !=null)
             {
              this.$Message.destroy()
             this.$Message.error(Message);
            }
    },
   },



})



// WEBPACK FOOTER //
// ./src/main.js